























import Vue from 'vue'
import { Component, Emit, Prop } from "vue-property-decorator"
import TrashIcon from "vue-ionicons/dist/md-trash.vue"

@Component({
    components: {TrashIcon},
})
export default class About extends Vue {
    @Prop({required: true}) title!: string
    @Prop({required: true}) text!: string
    @Prop({required: true}) imageUrl!: string
    @Prop({required: true}) date!: string
    @Prop({default: false}) showDeleteButton!: boolean
    @Prop({default: false}) deleting!: boolean

    get dateTime(): Date {
        return new Date(this.date)
    }

    get baseUrl(): String {
        return process.env.VUE_APP_BASE_URL
    }

    @Emit()
    onDelete() {}
}
